import { HeartIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const UnfilledHeart = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <HeartIcon size={Sizes[size]} color={fill || stroke} {...rest} />;
};

UnfilledHeart.displayName = 'UnfilledHeart';
